import spriteSheet from '../../assets/Spritesheet.png'
import spriteSheet2 from '../../assets/Spritesheet2.png'
import * as game from './Game.js'
import * as online from './MultiplayerGame'

export const State = {
  states: {},
  createState: function(name, startIndex, endIndex, startYIndex, endYIndex) {
    if (!this.states[name]) {
      this.states[name] = {
        frameIndex: startIndex,
        startIndex: startIndex,
        endIndex: endIndex,
        frameYIndex: startYIndex,
        startYIndex: startYIndex,
        endYIndex: endYIndex
      }
    }
  },
  getState: function(name, alreadyCalled) {
    if (this.states[name]) {
      if (alreadyCalled === false){
        this.states[name].frameIndex = this.states[name].startIndex
        this.states[name].frameYIndex = this.states[name].startYIndex
        called = true
        called2 = true
      }
      return this.states[name];
    }
  }
}

State.createState("Run", 0, 2, 4, 5)
State.createState("Ascend", 0, 2, 0, 2)
State.createState("Descend", 1, 1, 3, 3)

State.createState("Run2", 0, 2, 4, 5)
State.createState("Ascend2", 0, 2, 0, 2)
State.createState("Descend2", 1, 1, 3, 3)
let called = false
let called2 = false
export function animate(state, player, ctx){
  const frameWidth = 512;
  const frameHeight = 512;
  const scale = 0.20;
  const fps = 60;
  const secondsToUpdate = 1 * fps;
  let count = 0;
  
  let img = new Image();
  img.src = spriteSheet;

  function rerender() {
    count++
    if (count > 10){
      state.frameIndex++
      count = 0    
    }
    if (game.airState === "Ascend"){
      state = State.getState("Ascend", called)
    } else if (game.airState === "Descend"){
      state = State.getState("Descend", true)
    }

    if (game.airState === "Ascend" && state.frameYIndex == 2 && state.frameIndex >= 1) {
      state.frameIndex = 1
    }

    if (game.isGrounded){
      state = State.getState("Run", true)
      called = false
    }

    if (state.frameIndex > state.endIndex){
      state.frameYIndex++
      state.frameIndex = state.startIndex
    }
    
    if (state.frameYIndex > state.endYIndex){
      state.frameYIndex = state.startYIndex
    }   
    
    ctx.drawImage(
      img, // image
      state.frameIndex * frameWidth, // sx
      state.frameYIndex * frameHeight, // sy
      frameWidth,  // spriteWidth
      frameHeight, // spriteHeight
      player.position.x -  (frameWidth * scale) / 2, // dx
      player.position.y - (frameWidth * scale) / 1.2, // dy
      frameWidth * scale,// imgWidth
      frameHeight * scale// imgHeight
    );
    requestAnimationFrame(rerender);
  };
  rerender();
}


export function animateOnline(state1, state2, player1, player2, ctx){
  const frameWidth = 512;
  const frameHeight = 512;
  const scale = 0.20;
  const fps = 60;
  let count1 = 0;
  let count2 = 0;

  let img = new Image();
  img.src = spriteSheet;
  let img2 = new Image();
  img2.src = spriteSheet2;

  function rerender() {
    count1++
    if (count1 > 10){
      state1.frameIndex++
      count1 = 0    
    }
    if (online.P1airState === "Ascend"){
      state1 = State.getState("Ascend", called)
    } else if (online.P1airState === "Descend"){
      state1 = State.getState("Descend", true)
    }

    if (online.P1airState === "Ascend" && state1.frameYIndex == 1 && state1.frameIndex >= 1) {
      state1.frameIndex = 1
    }

    if (online.isP1Grounded){
      state1 = State.getState("Run", true)
      called = false
    }

    if (state1.frameIndex > state1.endIndex){
      state1.frameYIndex++
      state1.frameIndex = state1.startIndex
    }
    
    if (state1.frameYIndex > state1.endYIndex){
      state1.frameYIndex = state1.startYIndex
    }   
    
    ctx.drawImage(
      img, // image
      state1.frameIndex * frameWidth, // sx
      state1.frameYIndex * frameHeight, // sy
      frameWidth,  // spriteWidth
      frameHeight, // spriteHeight
      player1.position.x -  (frameWidth * scale) / 2, // dx
      player1.position.y - (frameWidth * scale) / 1.2, // dy
      frameWidth * scale,// imgWidth
      frameHeight * scale// imgHeight
    );

  };

  function rerender2() { 
    count2++
    if (count2 > 10){
      state2.frameIndex++
      count2 = 0    
    }
    if (online.P2airState === "Ascend"){
      state2 = State.getState("Ascend2", called2)
    } else if (online.P2airState === "Descend"){
      state2 = State.getState("Descend2", true)
    }

    if (online.P2airState === "Ascend" && state2.frameYIndex == 2 && state2.frameIndex >= 1) {
      state2.frameIndex = 1
    }

    if (online.isP2Grounded){
      state2 = State.getState("Run2", true)
      called2 = false
    }

    if (state2.frameIndex > state2.endIndex){
      state2.frameYIndex++
      state2.frameIndex = state2.startIndex
    }
    
    if (state2.frameYIndex > state2.endYIndex){
      state2.frameYIndex = state2.startYIndex
    }   

    ctx.drawImage(
      img2, // image
      state2.frameIndex * frameWidth, // sx
      state2.frameYIndex * frameHeight, // sy
      frameWidth,  // spriteWidth
      frameHeight, // spriteHeight
      player2.position.x -  (frameWidth * scale) / 2, // dx
      player2.position.y - (frameWidth * scale) / 1.2, // dy
      frameWidth * scale,// imgWidth
      frameHeight * scale// imgHeight
    );
  };

  function rerenderBoth(){
    online.EngineUpdate()
    rerender();
    rerender2();
    requestAnimationFrame(rerenderBoth)
  }

  rerenderBoth()

}